<aftp-preloader
  role="alert"
  aria-busy="true"
  aria-live="assertive"
></aftp-preloader>
